export const DisplayToggleOffset = 400;
